import { render, staticRenderFns } from "./NewGsCalendar.vue?vue&type=template&id=f2cec5a8"
import script from "./NewGsCalendar.vue?vue&type=script&lang=js"
export * from "./NewGsCalendar.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendar.vue?vue&type=style&index=0&id=f2cec5a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports